import { FileText, ExternalLink } from 'lucide-react';
import { Modal } from '@/components/ui/Modal';

// Previews a KYC document right where staff already are (application
// detail page) instead of opening a new tab — images render inline, PDFs
// load in an iframe (browsers' built-in PDF viewer), with an "Open in new
// tab" fallback either way.
export function DocumentPreviewModal({ url, label, onClose }: { url: string; label: string; onClose: () => void }) {
  const isPdf = /\.pdf(\?|$)/i.test(url);

  return (
    <Modal open onClose={onClose} title={label} icon={<FileText className="w-4 h-4" />} maxWidth="max-w-3xl">
      <div className="space-y-2.5">
        {isPdf ? (
          <iframe src={url} title={label} className="w-full rounded-lg border border-border-subtle" style={{ height: '70vh' }} />
        ) : (
          <img src={url} alt={label} className="w-full max-h-[70vh] object-contain rounded-lg border border-border-subtle bg-surface-muted" />
        )}
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1.5 text-[11.5px] font-semibold text-primary-800 hover:underline"
        >
          <ExternalLink className="w-3.5 h-3.5" /> Open in new tab
        </a>
      </div>
    </Modal>
  );
}
